import {Component, DestroyRef, EventEmitter, inject, OnInit, Output} from '@angular/core';
import { SupplierOutletService } from '../../app-shared/services/supplier-outlet.service';
import { Outlet } from '../../app-shared/models/supplier-outlet.model';
import { SettingsService } from '../../app-shared/services/settings.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Component({
    selector: 'app-select-outlet',
    templateUrl: './select-outlet.component.html',
    styleUrls: ['./select-outlet.component.scss'],
    standalone: false
})
export class SelectOutletComponent implements OnInit {
  outlets: Array<Outlet>;
  selectedOutletId: number;
  newOutlet: Outlet;
  mobile: boolean;

  // @Output() selectOutletForActivateCatalog = new EventEmitter();
  @Output() goNext = new EventEmitter();
  private readonly destroyRef = inject(DestroyRef);

  constructor(
    private supplierOutletService: SupplierOutletService,
    private settings: SettingsService,
    private router: Router,
    private translateService: TranslateService
  ) {
    this.mobile = this.settings.isMobileSize();
    this.newOutlet = {
      outletId: -1,
      outletName: this.translateService.instant('new_outlet'),
      address: this.translateService.instant('add_new_category_for_outlet'),
    };
  }

  ngOnInit(): void {
    this.supplierOutletService.getOutletsForActivateCatalog()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
      next: (res) => {
        this.outlets = res;
        const selectedOutlet =
          this.supplierOutletService.getSelectOutletForActivateCatalog();
        if (selectedOutlet) {
          this.selectOutlet(selectedOutlet);
        }
      },
      error: () => {
        this.supplierOutletService.removeSelectOutletForActivateCatalog();
        this.outlets = [];
      },
    });
  }

  selectOutlet(outlet: Outlet) {
    this.supplierOutletService.selectOutletForActivateCatalog(outlet);
    this.selectedOutletId = outlet.outletId;
    // this.selectOutletForActivateCatalog.emit(outlet);
  }

  clickNext() {
    this.goNext.emit();
    if (this.mobile) {
      this.router.navigate(['/addcategory/activate-outlet']);
    }
  }
}
